import * as React from "react";
import type { SVGProps } from "react";

interface SuspensionTwoPlusTenProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SuspensionTwoPlusTen = ({ cancelled = false, ...props }: SuspensionTwoPlusTenProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    {...props}
  >
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 1)">
        <ellipse cx={9.75} cy={12.925} fill="#FFF" rx={8.087} ry={8.143} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.986-.375a1.323 1.323 0 0 1 1.316 1.17c.007.472-.133.823-.348 1.072a1.26 1.26 0 0 1-.968.442l-.38.52a9.88 9.88 0 0 1 6.141 3.083 9.73 9.73 0 0 1 2.628 6.66 9.74 9.74 0 0 1-2.893 6.933 9.88 9.88 0 0 1-6.982 2.87 9.88 9.88 0 0 1-6.982-2.87A9.74 9.74 0 0 1-.375 12.57c0-2.57.997-4.91 2.628-6.659a9.88 9.88 0 0 1 6.141-3.083v-.52c-.746 0-1.077-.148-1.317-.388A1.32 1.32 0 0 1 6.69.984c0-.382.147-.717.38-.958.241-.25.575-.401.945-.401zM9.5 4.968a7.67 7.67 0 0 0-5.42 2.228 7.55 7.55 0 0 0-2.243 5.375c0 2.1.857 4 2.243 5.376a7.67 7.67 0 0 0 5.42 2.227 7.67 7.67 0 0 0 5.42-2.227 7.55 7.55 0 0 0 2.243-5.376c0-2.099-.857-4-2.243-5.375A7.67 7.67 0 0 0 9.5 4.968Z"
        />
      </g>
      <path
        fill="#FF1212"
        fillRule="nonzero"
        d="M10.248 20.5q-.48 0-.48-.528v-3.856l-.488.328q-.448.296-.696-.112-.127-.2-.076-.38t.268-.308l.912-.568a1.1 1.1 0 0 1 .656-.184q.376 0 .376.528v4.552q0 .528-.472.528m3.424.08q-.656 0-1.024-.328t-.512-.968-.144-1.584q0-.952.144-1.592t.512-.968 1.024-.328 1.016.328.508.968.148 1.592q0 .944-.148 1.584t-.508.968-1.016.328m0-.912a.55.55 0 0 0 .428-.172q.156-.172.224-.6a8 8 0 0 0 .068-1.196q0-.768-.068-1.2-.068-.433-.224-.604a.55.55 0 0 0-.428-.172.56.56 0 0 0-.432.172q-.16.172-.228.604a8 8 0 0 0-.068 1.2q0 .767.068 1.196.067.428.228.6.16.172.432.172M10.928 12q-.528 0-.528-.288 0-.375.12-.74.12-.364.404-.756t.772-.856q.24-.233.456-.464.216-.232.352-.46a.9.9 0 0 0 .144-.428q.007-.375-.164-.56-.172-.184-.5-.184-.408 0-.544.392-.08.24-.192.368-.113.128-.344.128a.44.44 0 0 1-.352-.148q-.128-.148-.072-.412.136-.592.536-.916t.968-.324q.464 0 .836.196.372.195.584.568t.196.916a1.54 1.54 0 0 1-.172.696q-.164.312-.44.612t-.636.644q-.344.344-.612.648t-.316.496h1.536q.528 0 .528.432 0 .44-.528.44z"
      />
      <path stroke="#000" strokeLinecap="round" d="M6 13.5h12.5" />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SuspensionTwoPlusTen;
